// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgGasIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M17.41 8.152a7.4 7.4 0 0 1 1.74 2.447 7.4 7.4 0 0 1 .628 2.992 7.38 7.38 0 0 1-2.166 5.243A7.35 7.35 0 0 1 12.389 21a7.37 7.37 0 0 1-5.223-2.168A7.384 7.384 0 0 1 5 13.589c0-1.137.26-2.259.76-3.277a7.5 7.5 0 0 1 2.105-2.58 6.2 6.2 0 0 0 .997-.98 6.1 6.1 0 0 0 .987-1.73c.189-.512.269-1.128.237-1.824l-.046-1.02c-.006-.133.139-.223.252-.155l.867.516c1.188.71 2.139 1.727 2.823 3.03.827 1.57.596 4.653.518 5.931a.13.13 0 0 0 .042.102c.031.03.067.034.09.032a.13.13 0 0 0 .086-.043L16 10l.526-2.345a.17.17 0 0 1 .118-.108.17.17 0 0 1 .155.038z"
    />
  </g>
);
export default SvgGasIcon;
SvgGasIcon.displayName = 'SvgGasIcon';
